import guilds from "../../data/guilds.json";

// Guild sub-sites render the whole site under /<slug> (e.g. /pga/drama-series).
// Switch a guild on or off with its "enabled" flag in data/guilds.json.
export const ENABLED_GUILDS = guilds.filter((guild) => guild.enabled);

export function getGuildFromPath(pathname = window.location.pathname) {
  const firstSegment = pathname.split("/")[1]?.toLowerCase();

  return ENABLED_GUILDS.find((guild) => guild.slug === firstSegment) || null;
}

// "/drama-series" -> "/pga/drama-series" while on a guild sub-site.
export function toGuildPath(path, guild = getGuildFromPath()) {
  if (!guild) return path;

  return path === "/" ? `/${guild.slug}` : `/${guild.slug}${path}`;
}

export function getGuildHomePath() {
  return toGuildPath("/");
}

// Query params that scope API responses to the current guild sub-site.
export function getGuildApiParams() {
  const guild = getGuildFromPath();

  return guild ? { guild: guild.guildId } : undefined;
}
